import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { logoutUser } from "../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { getUserRole } from "../../features/user/userSlice";
import { clearValues } from "../../features/dress/dressSlice";
export default function Sidebar() {
  const dispatch = useDispatch();
  const { user_role_id } = useSelector((state) => state.user);
  const [role, setRole] = React.useState("");
  useEffect(() => {
    if (user_role_id !== null) {
      setRole(user_role_id);
    } else {
      dispatch(getUserRole());
    }
  }, [user_role_id]);

  let activeStyle = {
    backgroundColor: "white",
  };
  let location = useLocation();
  function getNavLinkClass(path) {
    return location.pathname === path ? "active" : "";
  }
  return (
    <div className="SidebarNav">
      <ul className="links pt-5 nav-background">
        <li
          className={getNavLinkClass("/start-order")}
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <NavLink
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
            to="start-order"
            onClick={() => {
              dispatch(clearValues());
            }}
          >
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="18.4"
                height="18.4"
                viewBox="0 0 18.4 18.4"
              >
                <g id="inventory" transform="translate(-7.699 -5.9)">
                  <path
                    id="Path_9788"
                    data-name="Path 9788"
                    d="M20.7,14.4V6H9.5v8.4H6v9.8H24.2V14.4ZM10.2,6.7H20v7.7H10.2ZM23.5,23.5H6.7V15.1H23.5Z"
                    transform="translate(1.799)"
                    fill="#43425d"
                    stroke="#43425d"
                    strokeWidth="0.2"
                  />
                  <path
                    id="Path_9789"
                    data-name="Path 9789"
                    d="M24,18h5.6v.7H24Zm0,1.4h5.6v.7H24Zm4.9,7.7H24.7v-.7H24v1.4h5.6V26.4h-.7Z"
                    transform="translate(-9.901 -7.8)"
                    fill="#43425d"
                    stroke="#43425d"
                    strokeWidth="0.2"
                  />
                </g>
              </svg>
              <span
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
              >
                START AN ORDER
              </span>
            </div>
          </NavLink>
        </li>
        <li
          className={getNavLinkClass("/sales-order")}
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <NavLink to="/sales-order">
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="16.721"
                height="16.721"
                viewBox="0 0 16.721 16.721"
              >
                <g id="order" transform="translate(-2.25 -2.25)">
                  <path
                    id="Path_9842"
                    data-name="Path 9842"
                    d="M16.06,18.971H5.167A2.917,2.917,0,0,1,2.25,16.054V5.161A2.917,2.917,0,0,1,5.167,2.25H16.06a2.911,2.911,0,0,1,2.911,2.911V16.054a2.917,2.917,0,0,1-2.911,2.917ZM5.167,3.621a1.54,1.54,0,0,0-1.546,1.54V16.054A1.546,1.546,0,0,0,5.167,17.6H16.06a1.54,1.54,0,0,0,1.54-1.546V5.161a1.54,1.54,0,0,0-1.54-1.54Z"
                    fill="#43425d"
                  />
                  <path
                    id="Path_9843"
                    data-name="Path 9843"
                    d="M11.365,11.3a1.327,1.327,0,0,1-.548-.121,1.365,1.365,0,0,1-.8-1.255V2.935a.685.685,0,1,1,1.371,0V9.92l1.288-1.14a1.321,1.321,0,0,1,1.76,0l1.321,1.146-.044-6.99a.685.685,0,0,1,1.371,0V9.92a1.365,1.365,0,0,1-.8,1.255,1.321,1.321,0,0,1-1.431-.214l-1.3-1.129-1.3,1.135a1.321,1.321,0,0,1-.877.329ZM13.525,9.815ZM13.574,9.815Z"
                    transform="translate(-2.937)"
                    fill="#43425d"
                  />
                </g>
              </svg>
              <span
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
              >
                SALES ORDERS
              </span>
            </div>
          </NavLink>
        </li>
        <li
          className={getNavLinkClass("/invoices")}
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <NavLink to="invoices">
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="14.502"
                height="18.476"
                viewBox="0 0 14.502 18.476"
              >
                <g id="invoice" transform="translate(-98.788 -54.936)">
                  <path
                    id="Path_9846"
                    data-name="Path 9846"
                    d="M112.688,55.086H99.39a.452.452,0,0,0-.452.452V72.8a.452.452,0,0,0,.759.332l1.573-1.451a.45.45,0,0,1,.608,0l1.031.92a1.354,1.354,0,0,0,1.812,0l1.016-.917a.451.451,0,0,1,.606,0l1.016.917a1.354,1.354,0,0,0,1.812,0l1.031-.92a.45.45,0,0,1,.608,0l1.573,1.451a.452.452,0,0,0,.759-.332V55.538A.452.452,0,0,0,112.688,55.086Zm-.452,16.684-.814-.751A1.351,1.351,0,0,0,109.6,71l-1.031.92a.451.451,0,0,1-.6,0l-1.016-.917a1.353,1.353,0,0,0-1.817,0l-1.016.917a.451.451,0,0,1-.6,0L102.479,71a1.352,1.352,0,0,0-1.823.015l-.814.751V55.99h12.394V71.77Z"
                    fill="#43425d"
                    stroke="#43425d"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_9847"
                    data-name="Path 9847"
                    d="M186.046,190.865h-6.394a.5.5,0,1,0,0,1h6.394a.5.5,0,0,0,0-1Zm0,3.464h-6.394a.5.5,0,1,0,0,1h6.394a.5.5,0,0,0,0-1Z"
                    transform="translate(-76.919 -129.819)"
                    fill="#43425d"
                    stroke="#43425d"
                    strokeWidth="0.3"
                  />
                </g>
              </svg>
              <span
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
              >
                INVOICES
              </span>
            </div>
          </NavLink>
        </li>
        <li
          className={getNavLinkClass("/transaction-history")}
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <NavLink to="transaction-history">
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="18.854"
                height="13.333"
                viewBox="0 0 18.854 13.333"
              >
                <g id="credit" transform="translate(-34 -24)">
                  <path
                    id="Path_9791"
                    data-name="Path 9791"
                    d="M30.357,24H12.5a.506.506,0,0,0-.5.513V36.821a.506.506,0,0,0,.5.513H30.357a.506.506,0,0,0,.5-.513V24.513A.506.506,0,0,0,30.357,24Zm-.5,12.308H12.992V30.154H29.861Zm0-7.179H12.992V27.59H29.861Zm0-2.564H12.992V25.026H29.861Zm-9.427,7.692a.506.506,0,0,1-.5.513H14.977a.513.513,0,0,1,0-1.026h4.961A.506.506,0,0,1,20.435,34.256Z"
                    transform="translate(22)"
                    fill="#43425d"
                  />
                </g>
              </svg>
              <span
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
              >
                TRANSACTION HISTORY
              </span>
            </div>
          </NavLink>
        </li>
        <li
          className={getNavLinkClass("/payments")}
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <NavLink to="payments">
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="18.854"
                height="13.333"
                viewBox="0 0 18.854 13.333"
              >
                <g id="credit" transform="translate(-34 -24)">
                  <path
                    id="Path_9791"
                    data-name="Path 9791"
                    d="M30.357,24H12.5a.506.506,0,0,0-.5.513V36.821a.506.506,0,0,0,.5.513H30.357a.506.506,0,0,0,.5-.513V24.513A.506.506,0,0,0,30.357,24Zm-.5,12.308H12.992V30.154H29.861Zm0-7.179H12.992V27.59H29.861Zm0-2.564H12.992V25.026H29.861Zm-9.427,7.692a.506.506,0,0,1-.5.513H14.977a.513.513,0,0,1,0-1.026h4.961A.506.506,0,0,1,20.435,34.256Z"
                    transform="translate(22)"
                    fill="#43425d"
                  />
                </g>
              </svg>
              <span
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
              >
                Payment method
              </span>
            </div>
          </NavLink>
        </li>
        <li
          className={getNavLinkClass("/address")}
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <NavLink to="address">
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="18.854"
                height="13.333"
                viewBox="0 0 18.854 13.333"
              >
                <g id="credit" transform="translate(-34 -24)">
                  <path
                    id="Path_9791"
                    data-name="Path 9791"
                    d="M30.357,24H12.5a.506.506,0,0,0-.5.513V36.821a.506.506,0,0,0,.5.513H30.357a.506.506,0,0,0,.5-.513V24.513A.506.506,0,0,0,30.357,24Zm-.5,12.308H12.992V30.154H29.861Zm0-7.179H12.992V27.59H29.861Zm0-2.564H12.992V25.026H29.861Zm-9.427,7.692a.506.506,0,0,1-.5.513H14.977a.513.513,0,0,1,0-1.026h4.961A.506.506,0,0,1,20.435,34.256Z"
                    transform="translate(22)"
                    fill="#43425d"
                  />
                </g>
              </svg>
              <span
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
              >
                Address
              </span>
            </div>
          </NavLink>
        </li>
        {role === 1 && (
          <li
            className={getNavLinkClass("/settings")}
            onClick={() => {
              window.location.reload(false);
            }}
          >
            <NavLink to="settings">
              <div className="widthLinks">
                <svg
                  className="sidebar-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16.333"
                  height="17.193"
                  viewBox="0 0 16.333 17.193"
                >
                  <path
                    id="setting"
                    d="M.751,4.439a.686.686,0,0,1,.506.1.64.64,0,0,1,.193.876h0l-.049.1a.9.9,0,0,0,.4,1.15A2.224,2.224,0,0,1,1.767,10.5a.9.9,0,0,0-.348,1.246h0l.534.9a.917.917,0,0,0,.569.433.939.939,0,0,0,.714-.1,2.276,2.276,0,0,1,1.137-.294,2.293,2.293,0,0,1,2.32,2.265.933.933,0,0,0,.943.914h0l-.008.015a.676.676,0,0,1,.583.328.643.643,0,0,1,0,.657.676.676,0,0,1-.583.328,2.293,2.293,0,0,1-2.32-2.265.853.853,0,0,0-.124-.453.956.956,0,0,0-1.284-.34h0l-.137.067a2.35,2.35,0,0,1-2.955-.883h0l-.526-.9A2.236,2.236,0,0,1,1.118,9.4a.948.948,0,0,0,.34-.332.9.9,0,0,0,.153-.73.916.916,0,0,0-.455-.6h0l-.129-.082A2.233,2.233,0,0,1,.321,4.719h0l.066-.082A.677.677,0,0,1,.751,4.439ZM14.615,6.621a.7.7,0,0,1,.823.288.648.648,0,0,1-.232.9.948.948,0,0,0-.34.332.9.9,0,0,0-.1.7.917.917,0,0,0,.437.558,2.236,2.236,0,0,1,.8,3.1h0l-.526.9-.084.126a2.354,2.354,0,0,1-3.009.69.947.947,0,0,0-.943-.009.9.9,0,0,0-.464.8.682.682,0,0,1-1.353,0,2.257,2.257,0,0,1,1.157-1.914,2.369,2.369,0,0,1,2.276-.026.939.939,0,0,0,.711.1.964.964,0,0,0,.572-.43h0l.526-.9a.888.888,0,0,0,.1-.692.909.909,0,0,0-.437-.554,2.21,2.21,0,0,1-.843-.9,2.236,2.236,0,0,1,.835-3.02h0Zm-6.454-.86a2.936,2.936,0,0,1,2.055.827,2.8,2.8,0,0,1,.852,2h0l0,.171A2.844,2.844,0,0,1,9.28,11.221a2.959,2.959,0,0,1-3.171-.611,2.791,2.791,0,0,1-.634-3.095A2.909,2.909,0,0,1,8.162,5.761Zm0,1.329A1.511,1.511,0,1,0,9.708,8.6h0L9.7,8.476A1.532,1.532,0,0,0,8.162,7.09ZM8.7,0a2.293,2.293,0,0,1,2.32,2.265.853.853,0,0,0,.124.453.933.933,0,0,0,.569.431.955.955,0,0,0,.714-.092,2.351,2.351,0,0,1,3.093.815.663.663,0,0,1-.247.9.69.69,0,0,1-.92-.234h0l-.061-.089a.958.958,0,0,0-1.223-.243,2.368,2.368,0,0,1-2.273-.024,2.257,2.257,0,0,1-1.16-1.909.9.9,0,0,0-.263-.666A.947.947,0,0,0,8.7,1.329H7.636a.955.955,0,0,0-.675.278.91.91,0,0,0-.268.666A2.219,2.219,0,0,1,5.538,4.19,2.329,2.329,0,0,1,3.26,4.176h0l-.031-.03-.074-.052a.647.647,0,0,1-.142-.854.683.683,0,0,1,.928-.211.984.984,0,0,0,.464.128.957.957,0,0,0,.679-.243.912.912,0,0,0,.3-.641A2.291,2.291,0,0,1,7.636,0H8.7Z"
                    transform="translate(0)"
                    fill="#43425d"
                  />
                </svg>
                <span
                  data-bs-toggle="collapse"
                  data-bs-target=".navbar-collapse.show"
                >
                  SETTINGS
                </span>
              </div>
            </NavLink>
          </li>
        )}
        <li
          className={getNavLinkClass("/sign-out")}
          onClick={(e) => {
            dispatch(logoutUser());
            localStorage.clear();
            sessionStorage.clear();
          }}
        >
          <NavLink to="login">
            <div className="widthLinks">
              <svg
                className="sidebar-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
              >
                <g id="sign-out" transform="translate(0.451 0.691)">
                  <rect
                    id="Rectangle_681"
                    data-name="Rectangle 681"
                    width="21"
                    height="21"
                    transform="translate(-0.451 -0.691)"
                    fill="none"
                  />
                  <path
                    id="Path_9865"
                    data-name="Path 9865"
                    d="M174.011,86l3.332,3.333-3.332,3.333"
                    transform="translate(-160.431 -79.404)"
                    fill="none"
                    stroke="#43425d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                  <line
                    id="Line_41"
                    data-name="Line 41"
                    x2="8.885"
                    transform="translate(8.024 9.929)"
                    fill="none"
                    stroke="#43425d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_9866"
                    data-name="Path 9866"
                    d="M45.079,53.966H40.635A.635.635,0,0,1,40,53.331v-12.7A.635.635,0,0,1,40.635,40h4.444"
                    transform="translate(-37.055 -37.054)"
                    fill="none"
                    stroke="#43425d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                </g>
              </svg>
              SIGN Out
            </div>
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
